module.exports = {
  text: `Каждый из них сошёл с ума, подобно шляпнику. Ещё ни один дерро никогда не был в своём уме, но, видимо, для них это нормально`,
  author: `Архимаг Морденкайнен`,
}
